// src/services/api.js
import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('obs_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  r => r.data,
  err => Promise.reject(err.response?.data || err)
);

export const logsApi = {
  list:   (params) => api.get('/logs', { params }),
  stats:  ()       => api.get('/logs/stats'),
  volume: (params) => api.get('/logs/volume', { params }),
};

export const alertsApi = {
  list:        (params)      => api.get('/alerts', { params }),
  summary:     ()            => api.get('/alerts/summary'),
  create:      (body)        => api.post('/alerts', body),
  update:      (id, body)    => api.put(`/alerts/${id}`, body),
  delete:      (id)          => api.delete(`/alerts/${id}`),
  acknowledge: (id, userId)  => api.patch(`/alerts/${id}/acknowledge`, { userId }),
  resolve:     (id)          => api.patch(`/alerts/${id}/resolve`),
};

export const agentApi = {
  investigate:    (body)      => api.post('/agent/investigate', body),
  chat:           (body)      => api.post('/agent/chat', body),
  investigations: ()          => api.get('/agent/investigations'),
  investigation:  (id)        => api.get(`/agent/investigations/${id}`),
  chatHistory:    (sessionId) => api.get(`/agent/chat/${sessionId}`),
};

export const sourcesApi = {
  list:         ()             => api.get('/sources'),
  getConfig:    (type)         => api.get(`/sources/${type}/config`),
  updateConfig: (type, body)   => api.patch(`/sources/${type}/config`, body),
  resetConfig:  (type)         => api.delete(`/sources/${type}/config`),
  test:         (type, body)   => api.post(`/sources/${type}/test`, body),
};

export const analyticsApi = {
  overview: (params) => api.get('/analytics/overview', { params }),
  sources:  (params) => api.get('/analytics/sources', { params }),
};

export const dashboardsApi = {
  list:    ()                     => api.get('/dashboards'),
  get:     (uid)                  => api.get(`/dashboards/${uid}`),
  create:  (body)                 => api.post('/dashboards', body),
  update:  (uid, body)            => api.put(`/dashboards/${uid}`, body),
  versions:(uid)                  => api.get(`/dashboards/${uid}/versions`),
  restore: (uid, version)         => api.post(`/dashboards/${uid}/restore/${version}`),
  export:  (uid)                  => api.get(`/dashboards/${uid}/export`),
};

export const annotationsApi = {
  list:   (params) => api.get('/annotations', { params }),
  create: (body)   => api.post('/annotations', body),
  update: (id, body) => api.patch(`/annotations/${id}`, body),
  delete: (id)     => api.delete(`/annotations/${id}`),
};

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  me:    ()                 => api.get('/auth/me'),
};

export const orgsApi = {
  list:   ()           => api.get('/orgs'),
  get:    (id)         => api.get(`/orgs/${id}`),
  create: (body)       => api.post('/orgs', body),
  update: (id, body)   => api.put(`/orgs/${id}`, body),
  delete: (id)         => api.delete(`/orgs/${id}`),
};

export const projectsApi = {
  list:   (params)     => api.get('/projects', { params }),
  get:    (id)         => api.get(`/projects/${id}`),
  create: (body)       => api.post('/projects', body),
  update: (id, body)   => api.put(`/projects/${id}`, body),
  delete: (id)         => api.delete(`/projects/${id}`),
};

export const appsApi = {
  list:   (params)     => api.get('/apps', { params }),
  get:    (id)         => api.get(`/apps/${id}`),
  create: (body)       => api.post('/apps', body),
  update: (id, body)   => api.put(`/apps/${id}`, body),
  delete: (id)         => api.delete(`/apps/${id}`),
};

export const developersApi = {
  list:           (params)         => api.get('/developers', { params }),
  get:            (id)             => api.get(`/developers/${id}`),
  create:         (body)           => api.post('/developers', body),
  update:         (id, body)       => api.put(`/developers/${id}`, body),
  updatePerms:    (id, permissions) => api.patch(`/developers/${id}/permissions`, { permissions }),
  delete:         (id)             => api.delete(`/developers/${id}`),
};

export default api;
